export const INIT_KIOSK = 'INIT_KIOSK'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS'
export const SETUP_DIRECT_MESSAGE_LINK = 'SETUP_DIRECT_MESSAGE_LINK'
export const SET_REDIRECT = 'SET_REDIRECT'
export const SET_CHINESE_STATUS = 'SET_CHINESE_STATUS'
